import { Record } from 'immutable';

// ================================================================================================
// Rename Rules STore
// ================================================================================================

export const mkRenameRule = Record({
  id: undefined,
  clientId: undefined,
  isDeleted: undefined,
  renamePayeeFrom: undefined,
  renamePayeeTo: undefined,
  isDoNotRename: undefined,
  matchCriteria: 'If Payee Contains',
  applyToExistingTxns: undefined,
});
